console.log('加载gtag');

// 点击
var $ = jQuery;
$(function(){


  recommendPagesClickTrack('.recommend-product-home-inner');
  publicFlashSaleClickTrack();
  publicBannerClickTrack( '.public-banner-com','.public-banner-con','.public-banner-item-img')
  publicMultiButtonClickTrack('.public-multi-button-com','.public-multi-button-con','.public-multi-button-item-but','.public-multi-button-text');

  // recommendPagesClickTrack()
  // 普通秒杀组件点击事件 

  // 第二版
  function publicFlashSaleClickTrack() {
    console.log('普通组件埋点方法');
    
    const containers = document.querySelectorAll('.flash-sale-gtag-con');
  
    if (!containers.length) {
      console.warn('⚠️ 未找到 .flash-sale-wrapper 容器');
      return;
    }
  
    // console.log(`✅ 初始化 Flash Sale 点击打点，共找到 ${containers.length} 个组件`);
  
    containers.forEach((container, index) => {
      // 防止重复绑定
      if (container.__flash_click_bound__) return;
      container.__flash_click_bound__ = true;
  
      // 给每个组件加唯一标识，方便调试
      container.dataset.flashIndex = index;
  
      container.addEventListener('click', function (e) {
        const li = e.target.closest('.flash-sale-structure-product-con');
        // console.log("点击触发普通组件埋点-秒杀组件top", li);
        
        if (!li || !container.contains(li)) return;
        // console.log("点击事件触发-秒杀组件bot", li);
  
        const productBox = li.querySelector('.flash-sale-structure-product');
        // console.log('175行检车数据',productBox);
        if (!productBox) {
          // console.log('177行检车数据');
          // console.warn(`⚠️ 组件 #${index} 未找到 .flash-sale-item__right 元素`, li);
          return;
        }
        // console.log('181行检车数据');
        // 动态获取数据
        const item_id = productBox.dataset.productId || 'unknown_id';

        const item_name = li.querySelector('.title')?.innerText?.trim() || 'unknown_name';
        // console.log('183行检车数据', item_id, item_name);
  
        // 区分不同页面来源
        let routeName = window.location.pathname; // e.g. "/pages/flash-kill-page"
        let el = '';
        let event_category = '';
        let event_action = 'productClick';
        let event_name = 'select_item';
        let item_list_name = '';
  
        const match = routeName.match(/^\/pages\/([^\/]+)/); // 捕获 /pages/ 后面的名称
        if (match && match[1]) {
          event_category = match[1];
          item_list_name = `${match[1]}_productList-activity`;
          el = `${match[1]}_productList-activity`;
        } 
  
        // ✅ 调试打印
        // console.log(`🖱️ [组件 #${index}] 点击商品打点：`, {
        //   item_id,
        //   item_name,
        //   item_list_name,
        //   event_category,
        //   routeName,
        // });
  
        // ✅ 发送埋点
        if (typeof gtag === 'function') {
          gtag('event', event_name, {
            items: [
              {
                item_name,
                item_id,
                item_list_name,
              },
            ],
            event_category,
            event_action,
            event_label: el,
            send_to: 'G-F0NKM0YQCD',
          });
          // console.log(`✅ [组件 #${index}] 成功推送点击打点: ${item_name}`);
        } else {
          console.warn('⚠️ gtag 未定义，未发送打点');
        }
      });
    });
  }

  // 智能推荐点击埋点 多容器版本
  function recommendPagesClickTrack(containerSelector, recommendListName) {
    console.log('🔥 初始化智能推荐点击埋点，多容器版本', containerSelector);
  
    // 支持多个容器选择器
    const containers = document.querySelectorAll(containerSelector);
  
    if (containers.length === 0) {
      console.warn(`⚠️ 未找到容器：${containerSelector}`);
      return;
    }
  
    containers.forEach(container => {
  
      // 防止重复绑定
      if (container.__flash_click_bound__) return;
      container.__flash_click_bound__ = true;
  
      console.log(`📌 已绑定容器：`, container);
  
      // 事件委托
      container.addEventListener('click', function (e) {
  
        // console.log('➡️ 点击触发：', recommendListName);
  
        let li = e.target.closest('.Grid__Cell');
        if (!li || !container.contains(li)) return;
  
        const productBox = li.querySelector('.ProductItem');
        if (!productBox) return;
  
        let event_remark = li.classList.contains('gatg-li-default')
          ? 'product_default'
          : 'product_recommend';
  
        const item_id = productBox.dataset.productId || 'unknown_id';
        const item_name = li.querySelector('.ptit')?.innerText?.trim() || "unknown_name";
        let item_list_name = "";
        let routeName = window.location.pathname;
  
        let el = 'HomePage_Recommend'; 
        let event_category = "HomePage";
        let event_action = 'productClick';
        let event_name = 'select_item';
  
        let dataIndex, imgSrcLastPart;
        const promotion_name = li.querySelector('img')?.alt || "null";
        const match = routeName.match(/^\/pages\/([^\/]+)/);
  
        // ======= 页面逻辑 =======
        if (routeName !== "/") {
          // 普通页面
          if (match && match[1]) {
            event_category = match[1];
          }
  
          // 卡片 
          // img 
          if (productBox.querySelector("a .ProductItem_pic_img")) {
            const img = productBox.querySelector('source');
            if (img?.srcset) {
              const parts = img.srcset.trim().split('/');
              imgSrcLastPart = parts[parts.length - 1];
            }
            dataIndex = li.dataset.index;
  
            el = `${event_category}_Recommend::activity`;
            event_action = "promoClick";
            event_name = "select_promotion";
            event_remark='product_recommend';
            event_name_card_img(imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name,event_remark);
          }else if(productBox.querySelector(".ProductItem_video_img")){
            // video
            const img = productBox.querySelector('source');
            if (img?.srcset) {
              const parts = img.srcset.trim().split('/');
              imgSrcLastPart = parts[parts.length - 1];
            }
            dataIndex = li.dataset.index;
  
            el = `${event_category}_Recommend::video`;
            event_action = "promoClick";
            event_name = "select_promotion";
            event_remark='product_recommend';
            event_name_card_img(imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name,event_remark);
          }else {
            // 普通产品
            item_list_name = `${event_category}_Recommend`;
            el = item_list_name;
            event_name_product(event_name, item_name, item_id, item_list_name, event_category, event_action, el,event_remark);
          }
  
        } else {
          // ======= 首页 =======
  
          if (productBox.querySelector("a .ProductItem_pic_img")) {
            // 首页卡片
            const img = productBox.querySelector('source');
            if (img?.srcset) {
              const parts = img.srcset.trim().split('/');
              imgSrcLastPart = parts[parts.length - 1];
            }
            dataIndex = li.dataset.index;
  
            el = "HomePage_Recommend::activity";
            event_action = "promoClick";
            event_name = "select_promotion";
            
            event_remark='product_recommend';
  
            event_name_card_img(imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name,event_remark);
  
          }else if(productBox.querySelector(".ProductItem_video_img")){
            // video
            const img = productBox.querySelector('source');
            if (img?.srcset) {
              const parts = img.srcset.trim().split('/');
              imgSrcLastPart = parts[parts.length - 1];
            }
            dataIndex = li.dataset.index;
  
            el = `${event_category}_Recommend::video`;
            event_action = "promoClick";
            event_name = "select_promotion";
            event_remark='product_recommend';
            event_name_card_img( imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name,event_remark);
          } else {
            // 首页产品
            item_list_name = recommendListName || "HomePage_Recommend";
            el = item_list_name;
  
            event_name_product(event_name, item_name, item_id, item_list_name, event_category, event_action, el,event_remark);
          }
        }
  
        // 调试输出
        // console.log("🖱️ 点击埋点：", {
        //   el, item_id, item_name, item_list_name,
        //   routeName, dataIndex, imgSrcLastPart,
        //   event_action, event_name, event_remark
        // });
  
      }); // end click listener
  
    }); // end containers.forEach
    
  
    // ======== 公共方法封装 ========
    function event_name_product(event_name, item_name, item_id, item_list_name, event_category, event_action, el,event_remark) {
      gtag('event', event_name, {
        "items": [{
          item_name,
          item_id,
          item_list_name
        }],
        "event_category": event_category,
        "event_action": event_action,
        "event_label": el,
        "event_remark":event_remark,
        "send_to": "G-F0NKM0YQCD"
      });
    }
  
    function event_name_card_img(imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name,event_remark) {
      gtag('event', event_name, {
        "items": [{
          item_name: event_category,
          item_id: el,
          promotion_id: el,
          promotion_name: event_category,
          creative_name: imgSrcLastPart,
          creative_slot: dataIndex
        }],
        "event_category": event_category,
        "event_action": event_action,
        "event_label": el,
        "event_remark":event_remark,
        "send_to": "G-F0NKM0YQCD"
      });
    }
  }
  

  
 // 位于除顶部banner外 其他位置图片或轮播图点击 
  function publicBannerClickTrack(containerSelector, itemSelector, item) {
    // console.log('🔥 banner组件埋点初始化', containerSelector);
  
    // 支持多个容器
    const containers = document.querySelectorAll(containerSelector);
    if (!containers.length) return;
  
    containers.forEach((container, index) => {
      
      // 防重复绑定
      if (container.__banner_click_bound__) return;
      container.__banner_click_bound__ = true;
  
      container.dataset.bannerIndex = index;
  
      // 事件委托
      container.addEventListener('click', function (e) {
  
        const li = e.target.closest(itemSelector);
        if (!li || !container.contains(li)) return;
  
        const productBox = e.target.closest(item);
        if (!productBox) {
          console.warn(`⚠️ [banner #${index}] 未找到 item 元素：${item}`, li);
          return;
        }
  
        // ====== 动态数据 ======
        let routeName = window.location.pathname;
        let event_category = "";
        let item_list_name = "";
        let event_action = "promoClick";
        let event_name = "select_promotion";
        
        let el = "";
        let creative_name = "";
        let creative_slot = productBox.dataset.indexId || "";
  
        const match = routeName.match(/^\/pages\/([^\/]+)/);
  
        if (match && match[1]) {
          event_category = match[1];
          item_list_name = `${match[1]}_productList-activity`;
          el = `${match[1]}_pic-category`;
        } else {
          // 主页或其他无法解析路径的页面
          event_category = "HomePage";
          item_list_name = "HomePage_productList-activity";
          el = "HomePage_pic-category";
        }
  
        // 获取图片名称：source > img
        const source = productBox.querySelector('source');
        if (source?.srcset) {
          creative_name = source.srcset.split('/').pop();
        } else {
          // const img = productBox.querySelector('img');
          const img = productBox.matches('img')
                      ? productBox
                      : productBox.querySelector('img');

          creative_name = img?.src?.split('/').pop() || "unknown_img";
        }
  
        // ======= 调试输出 =======
        console.log("🟦 banner CLICK 埋点:", {
          event_category,
          el,
          creative_name,
          creative_slot,
          event_action,
          event_name
        });
  
        // ======= 发送 GA4 埋点 =======
        if (typeof gtag === "function") {
          gtag('event', event_name, {
            items: [{
              item_name: event_category,
              item_id: el,
              creative_slot,
              promotion_id: el,
              promotion_name: event_category,
              creative_name,
            }],
            event_category,
            event_action,
            event_label: el,
            send_to: "G-F0NKM0YQCD"
          });
        } else {
          console.warn("⚠️ gtag 未定义，无法发送埋点");
        }
  
      }); // end click
  
    }); // end containers.forEach
  }
  

  // 多组按钮
  function publicMultiButtonClickTrack(containerSelector,itemSelector,item,itemText ) {
    console.log('多组按钮组件埋点方法');
    
    const containers = document.querySelectorAll(containerSelector);
  
    if (!containers.length) {
      console.warn('⚠️ 未找到 .flash-sale-wrapper 容器');
      return;
    }
  
    // console.log(`✅ 初始化 Flash Sale 点击打点，共找到 ${containers.length} 个组件`);
  
    containers.forEach((container, index) => {
      // 防止重复绑定
      if (container.__flash_click_bound__) return;
      container.__flash_click_bound__ = true;
  
      // 给每个组件加唯一标识，方便调试
      container.dataset.flashIndex = index;
  
      container.addEventListener('click', function (e) {
        const li = e.target.closest(itemSelector);
        // console.log("点击触发普通组件banner", li);
        
        if (!li || !container.contains(li)) return;
        // console.log("点击事件触发普通组件banner326", li);
  
        // const productBox = li.querySelector(item);
        const productBox = e.target.closest(item);
        // console.log('175行检车数据',productBox);
        if (!productBox) {
          // console.log('177行检车数据');
          // console.warn(`⚠️ 组件 #${index} 未找到 .flash-sale-item__right 元素`, li);
          return;
        }
        // console.log('181行检车数据');
        // 动态获取数据
        // const item_id = productBox.dataset.productId || 'unknown_id';

        // const item_name = li.querySelector('.title')?.innerText?.trim() || 'unknown_name';
        // console.log('183行检车数据 ');
  
        // 区分不同页面来源
        let routeName = window.location.pathname; // e.g. "/pages/flash-kill-page"
        let el = '';
        let event_category = '';
        let event_action = 'promoClick';
        let event_name = 'select_promotion';
        let creative_name = '';
        let creative_slot =  productBox.dataset.indexId;
        let title = productBox.querySelector(itemText);
        let promotion_name = title ? title.innerText.trim() : '';
  
        const match = routeName.match(/^\/pages\/([^\/]+)/); // 捕获 /pages/ 后面的名称
        if (match && match[1]) {
          event_category = match[1];
          item_list_name = `${match[1]}_productList-activity`;
          el = `${match[1]}_promotion-categories`;
        } 
        // === 卡片曝光 ===
        if (productBox) {
          // console.log('productBox存在');
          
          const source = productBox.querySelector('source');



          // if (img?.src) creative_slot = img.src.split('/').pop();
          // img && img.srcset
          if (source) {
            // console.log('获取source标签');
            creative_name = source.srcset.split('/').pop();
          }else{
            // console.log('获取img标签');
            const img = productBox.querySelector('img');
            creative_name = img.src.split('/').pop();
          }
          // el = `${event_category}_Recommend::activity`;
          // event_action = 'promoView';
          // event_name = 'view_promotion图片';
        }else{
          // console.log('productBox不存在');
        }
  
        // ✅ 调试打印
        // console.log('👀除顶部banner 曝光推送:', {
            
        //     event_category,
        //     creative_slot,
        //     creative_name,
        //     promotion_name,
        //     el,
        //     event_action,
        //   });
  
        // ✅ 发送埋点
        if (typeof gtag === 'function') {
          gtag('event', event_name, {
            items: [{
              item_name:promotion_name,
              item_id: el,
              creative_slot,
              promotion_id:el,
              promotion_name:promotion_name,
              creative_name,
            }],
            event_category,
            event_action,
            event_label: el,
            send_to: "G-F0NKM0YQCD"
          });
          // console.log(`✅ [组件 #${index}] 成功推送点击打点: ${item_name}`);
        } else {
          console.warn('⚠️ gtag 未定义，未发送打点');
        }
      });
    });
  }

})


// 曝光
var $ = jQuery;
$(function () {
    console.log("曝光加载105");

    //秒杀通用曝光 四

 
    function publicFlashSaleViewPages(containerSelector) {
      console.log('✅ 通用初始化 组件曝光监听产品秒杀1116545');
    
      const containers = document.querySelectorAll(containerSelector);
      if (!containers.length) {
        console.warn(`❌ 未找到容器: ${containerSelector}`);
        return;
      }
      console.log('产品秒杀561');
      
      // 使用 WeakMap 给每个容器单独维护曝光 Set
      const containerExposeMap = new WeakMap();
      // console.log('产品秒杀565');
      // === 创建 IntersectionObserver（只在元素进入视口时触发）===
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
    
          const li = entry.target;
          const container = li.closest(containerSelector); 
          if (!container) return;
          // console.log('产品秒杀574');
          // 获取该容器对应的曝光记录（如果没有则创建）
          let exposedIds = containerExposeMap.get(container);
          if (!exposedIds) {
            exposedIds = new Set();
            containerExposeMap.set(container, exposedIds);
          }
          // console.log('产品秒杀581');
          const productBox = li.querySelector('[productid]') || li.querySelector('[data-product-id]');
          if (!productBox) return;
    
          const item_id = productBox.getAttribute('productid') || productBox.dataset.productId || 'unknown_id';
          const item_name = li.querySelector('.title')?.innerText?.trim() || 'unknown_name';
    
          // --- 去重关键：仅对同一个 container 进行去重 ---
          const uniqueKey = item_id;
          // console.log('产品秒杀590');
          if (exposedIds.has(uniqueKey)) {
            observer.unobserve(li);
            return;
          }
          // console.log('秒杀产品594');
          
          exposedIds.add(uniqueKey);
    
          // 页面信息
          const routeName = window.location.pathname;
          let event_category = '';
          let item_list_name = '_productList-activity';
          let el = '_productList-activity';
          let event_action = 'productView';
          let event_name = 'view_item_list';
    
          const match = routeName.match(/^\/pages\/([^\/]+)/);
          if (match && match[1]) {
            event_category = match[1];
            item_list_name = `${match[1]}_productList-activity`;
            el = `${match[1]}_productList-activity`;
          }
    
          // === GA 打点 ===
          if (typeof gtag === 'function') {
            gtag('event', event_name, {
              "items": [{
                item_name,
                item_id,
                item_list_name
              }],
              "event_category": event_category,
              "event_action": event_action,
              "event_label": el,
              "send_to": "G-F0NKM0YQCD"
            });
          } else {
            console.warn('⚠️ gtag 未定义，曝光未发送');
          }
    
          observer.unobserve(li);
        });
      }, {
        threshold: 0.3
      });
    
    
      // === 监听函数：绑定 observer 到容器内所有 li ===
      function observeItems(container) {
        const items = container.querySelectorAll('.flash-sale-structure-product-con');
    
        let exposedIds = containerExposeMap.get(container);
        if (!exposedIds) {
          exposedIds = new Set();
          containerExposeMap.set(container, exposedIds);
        }
    
        items.forEach(li => {
          const productBox = li.querySelector('[productid]') || li.querySelector('[data-product-id]');
          if (!productBox) return;
    
          let item_id = productBox.getAttribute('productid') || productBox.dataset.productId || 'unknown_id';
          const uniqueKey = item_id;
    
          // 如果该 container 里还没有曝光，则绑定观察
          if (!exposedIds.has(uniqueKey)) observer.observe(li);
        });
      }
    
      // 初始化：对每个容器绑定
      containers.forEach(container => observeItems(container));
    
      // 动态监听
      containers.forEach(container => {
        const mutationObserver = new MutationObserver(() => observeItems(container));
        mutationObserver.observe(container, { childList: true, subtree: true });
      });
    
      // 滚动时检查（防止懒加载）
      window.addEventListener('scroll', () => {
        containers.forEach(container => observeItems(container));
      });
    }
    
    // 智能推荐通用曝光 三 
    function trackExposure(containerSelector, itemSelector) {
      console.log('✅ 初始化 智能推荐组件曝光监听');
    
      const containers = document.querySelectorAll(containerSelector);
      if (!containers.length) {
        console.warn(`❌ 未找到容器: ${containerSelector}`);
        return;
      }
    
      // 只按 DOM 盒子去重（每个 .Grid__Cell 只曝光一次）
      window.__EXPOSED_BOXES__ = window.__EXPOSED_BOXES__ || new WeakSet();
      const exposedBoxes = window.__EXPOSED_BOXES__;
    
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
    
          const li = entry.target;
    
          // === DOM 去重 ===
          if (exposedBoxes.has(li)) {
            observer.unobserve(li);
            return;
          }
          exposedBoxes.add(li);
    
          // 是否为卡片
          const productBox = li.querySelector('[productid]') || li.querySelector('[data-product-id]');
          const isCard = !productBox;
    
          // === 事件 remark 判断 ===
          const event_remark = li.classList.contains('gatg-li-default')
            ? 'product_default'
            : 'product_recommend';
    
          

  
    
          const routeName = window.location.pathname;
          let event_category = routeName === '/'
            ? 'HomePage'
            : (routeName.match(/^\/pages\/([^\/]+)/)?.[1] || 'Unknown_Page');
    
          let item_list_name = `${event_category}_Recommend`;
          let el = item_list_name;
          let item_name = ''
          let event_action = 'productView';
          let event_name = 'view_item_list';
          let creative_slot = 'null';
          let creative_name = 'null'
          let item_id = isCard
          ? `card_${li.dataset.index || creative_slot || 'unknown'}`
          : (productBox?.getAttribute('productid') ??
             productBox?.dataset.productId ??
             null);
          
    
          // === 卡片曝光 ===
          if (isCard) {
            const img = li.querySelector('.ProductItem_pic_img img');
            // const video = li.querySelector('.ProductItem_video_img');
            const video = li.querySelector('.ProductItem_video_img') ? li.querySelector('.ProductItem_video_img') : false;
            const sourceSrc = li.querySelector('source');
            const imgSrc = li.querySelector('img');
            creative_name =
             (sourceSrc?.srcset && sourceSrc.srcset.split('/').pop()) ||
             (imgSrc?.src && imgSrc.src.split('/').pop()) ||
             null;

            if (img) {

              // if (img?.src) creative_slot = img.src.split('/').pop();
      
              el = `${event_category}_Recommend::activity`;
              event_action = 'promoView';
              event_name = 'view_promotion';
              item_name = event_category;
            }else if (video) {
              el = `${event_category}_Recommend::video`;
              event_action = 'promoView';
              event_name = 'view_promotion';
              item_name = event_category;
            }
            // item_name = event_category;
            item_id = el;

            // 走卡片单独推送
            if (typeof gtag === 'function') {
              gtag('event', event_name, {
                items: [{
                  item_name,
                  item_id,
                  promotion_id:el,
                  promotion_name:event_category,
                  creative_name,
                  creative_slot
                }],
                event_category,
                event_action,
                event_label: el,
                event_remark, // ← ★ 新增字段
                send_to: "G-F0NKM0YQCD"
              });
            }

          }else{
            // console.log('打印底部inner的li',li);
            // console.log('打印底部inner的productBox',productBox);
              // === 取商品名 ===
               setTimeout(() => {
                  const item_name = productBox.querySelector('.ptit')?.innerText?.trim() || 'null';
                  // console.log("最终 item_name:", item_name);

                  // 走产品推送
                  if (typeof gtag === 'function') {
                    gtag('event', event_name, {
                      items: [{
                        item_name,
                        item_id,
                        item_list_name
                      }],
                      event_category,
                      event_action,
                      event_label: el,
                      event_remark, // ← ★ 新增字段
                      send_to: "G-F0NKM0YQCD"
                    });
                  }

                }, 100);
               
            
          }
    
          // console.log('👀 曝光推送:', {
            // : isCard
            // ? `card_${li.dataset.index || creative_slot || 'unknown'}`
            // : (productBox?.getAttribute('productid') || productBox?.dataset.productId || 'unknown')
          //   item_name,
          //   isCard,
          //   event_category,
          //   event_name,
          //   event_action,
          //   event_remark
          // });
    
          
    
          observer.unobserve(li);
        });
      }, { threshold: 0.3 });
    
      // === 绑定 observer 到每个 Grid__Cell ===
      function observeItems(container) {
        const items = container.querySelectorAll(itemSelector);
        items.forEach(li => {
          if (!exposedBoxes.has(li)) observer.observe(li);
        });
      }
    
      containers.forEach(container => observeItems(container));
    
      // 动态内容监听
      containers.forEach(container => {
        const mutationObserver = new MutationObserver(() => observeItems(container));
        mutationObserver.observe(container, { childList: true, subtree: true });
      });
    
      // 滚动检测
      window.addEventListener('scroll', () => {
        containers.forEach(container => observeItems(container));
      });
    }
    
    // 位于除顶部banner外 其他位置图片或轮播图


    function publicBannerViewPages(containerSelector, itemSelector) {
      console.log('✅ 初始化 智能推荐组件曝光监听banner ');
    
      const containers = document.querySelectorAll(containerSelector);
      if (!containers.length) {
        console.warn(`❌ 未找到容器: ${containerSelector}`);
        return;
      }
    
      // 只按 DOM 盒子去重（每个 .Grid__Cell 只曝光一次）
      window.__EXPOSED_BOXES__ = window.__EXPOSED_BOXES__ || new WeakSet();
      const exposedBoxes = window.__EXPOSED_BOXES__;
    
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
    
          const li = entry.target;
          // console.log('打印li的内容',li);
          
    
          // === DOM 去重 ===
          if (exposedBoxes.has(li)) {
            observer.unobserve(li);
            return;
          }
          exposedBoxes.add(li);
    
          // 是否为卡片
          // li 本身有 data-index-id
          // if (li.hasAttribute('data-index-id')) {
          //   productBox = li;
          // } else {
          //   // 否则找内部的 productid
          //   productBox = li.querySelector('[productid]');
          // }
          const productBox = li.hasAttribute('data-index-id') ?  li : li.querySelector('[productid]')

          // const productBox = li.querySelector('[productid]') || li.querySelector('[data-index-id]');
          // const isCard = !productBox;
          // console.log('打印productBox',productBox);
          
          // === 事件 remark 判断 ===
          // const event_remark = li.classList.contains('gatg-li-default')
          //   ? 'product_default'
          //   : 'product_recommend';
    
          // === 取商品名 ===
          // const item_name = li.querySelector('.ptit')?.innerText?.trim() || 'unknown_name';
          
    
          const routeName = window.location.pathname;
          let event_category = routeName === '/'
            ? 'HomePage'
            : (routeName.match(/^\/pages\/([^\/]+)/)?.[1] || 'Unknown_Page');
    
          let item_id = 'null';
          let el = `${event_category}_pic-category`;
    
          let event_action = 'promoView';
          let event_name = 'view_promotion';
          let creative_slot =  productBox.dataset.indexId;
          let creative_name = '';
          let item_name =`${event_category}`;
          let promotion_name = `${event_category}`;
    
          // === 卡片曝光 ===
          if (productBox) {
            // console.log('productBox存在');
            
            const source = productBox.querySelector('source');



            // if (img?.src) creative_slot = img.src.split('/').pop();
            // img && img.srcset
            if (source) {
              // console.log('获取source标签');
              creative_name = source.srcset.split('/').pop();
            }else{
              // console.log('获取img标签');
              const img = productBox.matches('img')
                          ? productBox
                          : productBox.querySelector('img');

              creative_name = img.src.split('/').pop();
            }
            // el = `${event_category}_Recommend::activity`;
            // event_action = 'promoView';
            // event_name = 'view_promotion图片';
          }else{
            // console.log('productBox不存在');
          }
    
          // console.log('👀除顶部banner 曝光推送:', {
          //   item_name,
          //   item_id ,
          //   creative_slot,
          //   promotion_name,
          //   creative_name,
          //   el,
          //   event_action,
          // });
    
          if (typeof gtag === 'function') {
            gtag('event', event_name, {
              items: [{
                item_name,
                item_id: el,
                creative_slot,
                promotion_id:el,
                promotion_name,
                creative_name,
              }],
              event_category,
              event_action,
              event_label: el,
              send_to: "G-F0NKM0YQCD"
            });
          }
    
          observer.unobserve(li);
        });
      }, { threshold: 0.3 });
    
      // === 绑定 observer 到每个 Grid__Cell ===
      function observeItems(container) {
        const items = container.querySelectorAll(itemSelector);
        items.forEach(li => {
          if (!exposedBoxes.has(li)) observer.observe(li);
        });
      }
    
      containers.forEach(container => observeItems(container));
    
      // 动态内容监听
      containers.forEach(container => {
        const mutationObserver = new MutationObserver(() => observeItems(container));
        mutationObserver.observe(container, { childList: true, subtree: true });
      });
    
      // 滚动检测
      window.addEventListener('scroll', () => {
        containers.forEach(container => observeItems(container));
      });
    }

    // 多组按钮
    function publicMultiButtonViewPages(containerSelector, itemSelector,itemSelectText) {
      console.log('✅ 初始化 智能推荐组件曝光监听多组按钮圆形菜单 ');
    
      const containers = document.querySelectorAll(containerSelector);
      // console.log('圆形菜单997containers',containers);
      
      if (!containers.length) {
        console.warn(`❌ 未找到容器: ${containerSelector}`);
        return;
      }
      // console.log('圆形菜单1003');
      // 只按 DOM 盒子去重（每个 .Grid__Cell 只曝光一次）
      window.__EXPOSED_BOXES__ = window.__EXPOSED_BOXES__ || new WeakSet();
      const exposedBoxes = window.__EXPOSED_BOXES__;
    
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
    
          const li = entry.target;
          // console.log('打印li的内容圆形菜单',li);
          
    
          // === DOM 去重 ===
          if (exposedBoxes.has(li)) {
            observer.unobserve(li);
            return;
          }
          exposedBoxes.add(li);
    
          // 是否为卡片
          // li 本身有 data-index-id
          // if (li.hasAttribute('data-index-id')) {
          //   productBox = li;
          // } else {
          //   // 否则找内部的 productid
          //   productBox = li.querySelector('[productid]');
          // }
          const productBox = li.hasAttribute('data-index-id') ?  li : li.querySelector('[productid]')

          // const productBox = li.querySelector('[productid]') || li.querySelector('[data-index-id]');
          // const isCard = !productBox;
          // console.log('打印productBox圆形菜单',productBox);
          
          // === 事件 remark 判断 ===
          // const event_remark = li.classList.contains('gatg-li-default')
          //   ? 'product_default'
          //   : 'product_recommend';
    
          // === 取商品名 ===
          // const item_name = li.querySelector('.ptit')?.innerText?.trim() || 'unknown_name';
          
    
          const routeName = window.location.pathname;
          let event_category = routeName === '/'
            ? 'HomePage'
            : (routeName.match(/^\/pages\/([^\/]+)/)?.[1] || 'Unknown_Page');
    
          let item_id = 'null';
          let el = `${event_category}_promotion-categories`;
    
          let event_action = 'promoView';
          let event_name = 'view_promotion';
          let creative_slot =  productBox.dataset.indexId;
          let creative_name = '';
          let item_name =`${event_category}`;
          // let promotion_name =productBox.querySelector(itemSelectText).innerText().trim() ;
          let title = productBox.querySelector(itemSelectText);
          let promotion_name = title ? title.innerText.trim() : '';
    
          // === 卡片曝光 ===
          if (productBox) {
            // console.log('productBox存在圆形菜单');
            
            const source = productBox.querySelector('source');



            // if (img?.src) creative_slot = img.src.split('/').pop();
            // img && img.srcset
            if (source) {
              // console.log('获取source标签圆形菜单');
              creative_name = source.srcset.split('/').pop();
            }else{
              // console.log('获取img标签圆形菜单');
              const img = productBox.querySelector('img');
              creative_name = img.src.split('/').pop();
            }
            // el = `${event_category}_Recommend::activity`;
            // event_action = 'promoView';
            // event_name = 'view_promotion图片';
          }else{
            // console.log('productBox不存在圆形菜单');
          }
    
          // console.log('👀圆形菜单 曝光推送:', {
          //   item_name,
          //   item_id ,
          //   creative_slot,
          //   promotion_name,
          //   creative_name,
          //   el,
          //   event_action,
          // });
    
          if (typeof gtag === 'function') {
            gtag('event', event_name, {
              items: [{
                item_name:promotion_name,
                item_id: el,
                promotion_id: el,
                creative_slot,
                promotion_name,
                creative_name,
              }],
              event_category,
              event_action,
              event_label: el,
              send_to: "G-F0NKM0YQCD"
            });
          }
    
          observer.unobserve(li);
        });
      }, { threshold: 0.3 });
    
      // === 绑定 observer 到每个 Grid__Cell ===
      function observeItems(container) {
        const items = container.querySelectorAll(itemSelector);
        items.forEach(li => {
          if (!exposedBoxes.has(li)) observer.observe(li);
        });
      }
    
      containers.forEach(container => observeItems(container));
    
      // 动态内容监听
      containers.forEach(container => {
        const mutationObserver = new MutationObserver(() => observeItems(container));
        mutationObserver.observe(container, { childList: true, subtree: true });
      });
    
      // 滚动检测
      window.addEventListener('scroll', () => {
        containers.forEach(container => observeItems(container));
      });
    }
    
    
    
    

    
    $(function() {
      // console.log('加载362');
      
      // 非首页智能推荐 曝光事件
      trackExposure('.off-discount-coupon-gatg', '.ProductList--grid .Grid__Cell');
      
      trackExposure('.recommend-product-home-inner', '.ProductList--grid .Grid__Cell');
      //组件合集了列表
      trackExposure('.c-t-v-m-tab-content', '.c-t-v-m-tab-product-content-default .Grid__Cell-default');
      // 秒杀通用曝光
      publicFlashSaleViewPages('.flash-sale-gtag-con');
      // 位于除顶部banner外 其他位置图片或轮播图
      publicBannerViewPages('.public-banner-con','.public-banner-item-img');
      // 多组按钮
      publicMultiButtonViewPages('.public-multi-button-con','.public-multi-button-item-but','.public-multi-button-text');
      
    });
    
    
    
  });
  